import { graphql } from "@/lib/gql/__generated__/gql";

export const ExistingOptionI18nUpdate_EditPage_Mutation = graphql(/* GraphQL */ `
	mutation ExistingOptionI18nUpdate($input: OptionI18nInput!) {
		optionI18nUpdate(input: $input) {
			userErrors
			optionI18n {
				id
				lang
				hotelID
				optionID
				name
				description
				subOptions {
					subOptionID
					name
					startAt
					endAt
					isNextMorning
					memo
					maxDailyStockNum
					price {
						currencyType
						amount
					}
					isShowTimeSchedule
				}
			}
		}
	}
`);
